import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageHome from "./pages/PageHome";
import PageSpeakers from "./pages/PageSpeakers";
import PageSpeakers23 from "./pages/PageSpeakers23";
import PageSpeakers24 from "./pages/PageSpeakers24";
import PageSpeakers25 from "./pages/PageSpeakers25";
import PageAgenda from "./pages/PageAgenda";
import PageHotel from "./pages/PageHotel";
import PageExplore from "./pages/PageExplore";
import PageFAQ from "./pages/PageFAQ";
import PageRegistration from "./pages/PageRegistration";

import PageComingSoon from "./pages/PageComingSoon";

import PageSponsors from "./pages/PageSponsors";
import PageSponsorForm from "./pages/PageSponsorForm";
import PageSponsorHub from "./pages/PageSponsorHub";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          {/* Legacy Redirects */}
          <Route
            path="/form-register.html/*"
            element={<Navigate to="/Registration" replace />}
            caseSensitive={false}
          />
          <Route
            path="/form-sponsor.html/*"
            element={<Navigate to="/SponsorForm" replace />}
            caseSensitive={false}
          />
          <Route
            path="/registration.html/*"
            element={<Navigate to="/Registration" replace />}
            caseSensitive={false}
          />
          <Route
            path="/register.html/*"
            element={<Navigate to="/Registration" replace />}
            caseSensitive={false}
          />
          <Route
            path="/faq.html/*"
            element={<Navigate to="/FAQ" replace />}
            caseSensitive={false}
          />
          <Route
            path="/sponsors.html/*"
            element={<Navigate to="/Sponsors" replace />}
            caseSensitive={false}
          />
          <Route
            path="/agenda.html/*"
            element={<Navigate to="/Agenda" replace />}
            caseSensitive={false}
          />

          {/* Main Navigation */}
          {/* <Route path="/" element={<PageHome />} /> */}
          <Route path="/soon" element={<PageComingSoon />} />
          <Route path="/" element={<PageHome />} />
          <Route path="/speakers" element={<PageSpeakers />} />
          <Route path="/speakers/2025" element={<PageSpeakers25 />} />
          <Route path="/speakers/2024" element={<PageSpeakers24 />} />
          <Route path="/speakers/2023" element={<PageSpeakers23 />} />
          <Route path="/agenda" element={<PageAgenda />} />
          <Route path="/hotel" element={<PageHotel />} />
          <Route path="/visit" element={<PageExplore />} />
          <Route path="/sponsors" element={<PageSponsors />} />
          <Route path="/faq" element={<PageFAQ />} />
          <Route path="/registration" element={<PageRegistration />} />
          <Route path="/sponsorForm" element={<PageSponsorForm />} />
          <Route path="/sponsorHub" element={<PageSponsorHub />} />

          {/* 404 Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />

          <Route path="/" element={<PageComingSoon />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) return;

    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return null;
};

export default App;
